export const validateRequiredString = (value: string): string | undefined =>
  value ? undefined : 'Required';

export const validateNewPassword = (value: string): string | undefined =>
  value?.length > 6 ? undefined : 'Has to be longer than 6 characters';
